import { render, staticRenderFns } from "./sidebar-menu-mobile.component.vue?vue&type=template&id=c519f1aa&scoped=true"
import script from "./sidebar-menu-mobile.component.vue?vue&type=script&lang=js"
export * from "./sidebar-menu-mobile.component.vue?vue&type=script&lang=js"
import style0 from "./sidebar-menu-mobile.component.vue?vue&type=style&index=0&id=c519f1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c519f1aa",
  null
  
)

export default component.exports